export default __webpack_public_path__ + "static/media/goshen77.7b31e033.jpg";